import { TFiveOrSixUtpBlock } from 'shared/types/utp';

export const UTP: TFiveOrSixUtpBlock = [
  { title: [{ value: 'Расширяет экосистему за пределы поиска объектов' }], image: 'square' },
  { title: [{ value: 'Увеличивает монетизацию за счёт дополнительных сервисов' }], image: 'ruble' },
  {
    title: [{ value: 'Повышает ценность платформы для пользователей и корпоративных клиентов' }],
    image: 'star-in-circle',
  },
  {
    title: [{ value: 'Укрепляет лояльность пользователей, закрывая больше этапов сделки внутри Циан' }],
    image: 'monitor',
  },
  { title: [{ value: 'Поддерживает позицию Циан как технологического лидера рынка недвижимости' }], image: 'house' },
];
